<!--
	Copyright (c) 2017-present, flop! contributors
	SPDX-License-Identifier: AGPL-3.0-or-later
	https://framagit.org/flopedt/flopedt
-->

<script setup lang="ts">
import { DropdownMenuGroup as RekaDropdownMenuGroup } from 'reka-ui'

defineSlots<{ default(props: {}): unknown }>()
</script>

<template>
  <RekaDropdownMenuGroup>
    <slot />
  </RekaDropdownMenuGroup>
</template>
